import { useEffect, useState } from 'react';
import type { MeResponse } from '@hearth/shared';
import { useAuth } from '../auth/AuthProvider';
import { AdminPage } from './Admin';
import { CreatePage } from './Create';
import { ServerPage, type ServerTab } from './ServerPage';
import { Servers } from './Servers';
import { Shell } from './Shell';

/**
 * The signed-in pages: /app (servers) and /app/servers/{id} (a server).
 * Who you are is read first: it decides, for one, whether you're still waiting for approval.
 */
export function Home({ serverId, tab, page }: { serverId?: string; tab?: ServerTab; page?: 'admin' | 'new' }) {
  const { api, signOut } = useAuth();
  const [me, setMe] = useState<MeResponse>();
  const [error, setError] = useState('');

  useEffect(() => {
    if (!api) return;
    api.get<MeResponse>('/v1/me').then(setMe, (err: unknown) => setError(err instanceof Error ? err.message : 'Something went wrong.'));
  }, [api]);

  return (
    <Shell me={me} api={api} onSignOut={signOut}>
      {error ? (
        <div className="card" role="alert"><h1>Couldn't load your account</h1><p>{error}</p></div>
      ) : !me || !api ? (
        <p className="quiet" aria-live="polite">Loading…</p>
      ) : page === 'new' ? (
        <CreatePage api={api} me={me} />
      ) : page === 'admin' ? (
        <AdminPage api={api} me={me} />
      ) : serverId ? (
        <ServerPage api={api} serverId={serverId} meId={me.userId} tab={tab} />
      ) : (
        <Servers api={api} me={me} />
      )}
    </Shell>
  );
}
